import { IsInAgentService, IsInAgentServiceImpl } from '@/components/ai/plugins/seek/services/is-in-agent-service';
import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { PageInitService } from './services/page-init-service';
import { PageApi } from './apis/page-api';
import { PageApiImpl } from './apis/impls/page-api';
import { PageRepository } from './services/page-repository';
import { PageModelImpl } from './models/impls/page-model';
import { PageModel } from './models/page-model';
import { PageRepositoryImpl } from './repositories/impls/page-repository';
import { PageInitServiceImpl } from './services/impls/page-init-service';
import { PageDataServiceImpl } from './services/impls/page-data-service';
import { PageDataService } from './services/page-data-service';

export const seekContainer = new ContainerModule(bind => {
    bind(PageInitService).to(PageInitServiceImpl);
    bind(PageModel).to(PageModelImpl);
    bind(PageRepository).to(PageRepositoryImpl);
    bind(PageApi).to(PageApiImpl);
    bind(PageDataService).to(PageDataServiceImpl);
    bind(IsInAgentService).to(IsInAgentServiceImpl);
});
